import React from "react"
import FontAwesome from "react-fontawesome"
const { Row, Col, Image } = require("react-bootstrap")

export default function OrganizationLocked() {

  return (
    <div className="lockedMainContent">

      <Row>
        <Col mdOffset={2} md={4}>
          <Image 
            src={require("../../files/company-logo.png")} 
            alt="organizationMissing"
            rounded
            width="100%"
          />
          <p>
            <a href="#back" onClick={() => window.history.back()}>
            <FontAwesome name='long-arrow-left' size="2x"/> Back</a>
          </p>
        </Col>

        <Col md={4} id="lockedText">
          <p><FontAwesome name='lock' size="5x"/></p>
          <h1>
            Your organization is locked, please conctact your IT Admin.
          </h1>
        </Col>
      </Row>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Organizations/OrganizationLocked.js